<template
  ><section class="section">
    <b-loading isFullPage :active="isLoading" />
    <h1 class="title is-size-5 has-text-color-7">
      {{
        id ? App.PartAddressScreen.EDIT_FORM : App.PartAddressScreen.NEW_FORM
      }}
    </h1>

    <section class="columns is-multiline is-5">
      <b-field
        :label="General.ORGAN_ENTITY"
        class="column is-12 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <div class="columns m-0">
          <b-autocomplete
            v-model="partAddressData.partDataName"
            :disabled="disabledPartField"
            :data="filteredParts"
            autocomplete
            field="displayName"
            name="part"
            class="column is-10 is-paddingless"
            :placeholder="App.PartAddressScreen.PLACEHOLDER.ORGAN_ENTITY"
            keepFirst
            @typing="getPart"
            @select="option => setPartData(option)"
          />
          <b-checkbox
            v-model="partAddressData.bound"
            class="column is-10 has-text-color-7"
            :class="{ 'spacing-mx-10': !isMobile }"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
            nativeValue="true"
            @input="checkInput()"
          >
            {{ App.PartAddressScreen.LINKED }}
          </b-checkbox>
        </div>
      </b-field>

      <!-- DEPRIORITIZED -->

      <!-- <b-field class="column is-12 mb-0 py-5" customClass="has-text-blue-oil">
        <template slot="label">
          <div
            class="is-6 has-text-weight-semibold is-flex is-align-items-center"
          >
            {{ General.UNITY }}
            <span class="optional-label ml-5">{{ General.OPTIONAL }}</span>
            <b-tooltip
              multilined
              type="is-blue-oil"
              size="is-large"
              position="is-right"
            >
              <template v-slot:content>
                <div class="has-text-left">
                  <b>
                    {{ General.HELP }}
                  </b>
                  <p>
                    {{ General.TEXTS.DESCRIPTION_ORGAN_UNITY }}
                  </p>
                </div>
              </template>
              <div class="is-flex">
                <b-icon
                  class="spacing-ml-5"
                  type="is-blue-oil"
                  size="is-small"
                  icon="information"
                />
              </div>
            </b-tooltip>
          </div>
        </template>
        <div class="is-flex is-flex-direction-column">
          <b-autocomplete
            v-model="partAddressData.capacityDataName"
            :data="
              getCapacityByOrgan(filterCapacityTo, partAddressData.partDataName)
            "
            autocomplete
            field="name"
            name="capacity"
            :placeholder="App.PartAddressScreen.PLACEHOLDER.ORGAN_UNITY"
            :disabled="disabledCapacityField"
            @typing="setFilterCapacityTo"
            @select="option => setCapacityData(option)"
          />
        </div>
      </b-field>
      <div class="column is-12 pt-0">
        <b-checkbox
          v-model="partAddressData.isApplicableUnity"
          type="is-blue-oil"
          nativeValue="true"
        >
          {{ App.PartAddressScreen.APPLICABLE_TO_UNITY }}
        </b-checkbox>
      </div> -->
      <b-field
        :label="General.CEP.toUpperCase()"
        class="column is-6 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.zipCode"
          v-mask="`#####-###`"
          :placeholder="App.PartAddressScreen.PLACEHOLDER.CEP"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <div class="column is-6 empty"></div>

      <b-field
        :label="`${General.ADDRESS} (rua, avenida...)`"
        class="column is-7 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.street"
          maxlength="150"
          :hasCounter="false"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <b-field
        :label="General.NUMBER"
        class="column is-1 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.number"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <b-field
        :label="General.COMPLEMENT"
        class="column is-4 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input v-model="partAddressData.complement" disabled />
      </b-field>

      <b-field
        :label="General.DISTRICT"
        class="column is-4 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.district"
          maxlength="30"
          :hasCounter="false"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <b-field
        :label="General.CITY"
        class="column is-4 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.city"
          maxlength="50"
          :hasCounter="false"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <b-field
        :label="General.STATE"
        class="column is-4 mb-0 py-5"
        customClass="has-text-color-7"
      >
        <b-input
          v-model="partAddressData.state"
          maxlength="50"
          :hasCounter="false"
          :disabled="!partAddressData.capacityDataName"
        />
      </b-field>

      <b-field class="column is-12 mb-0 py-5" customClass="has-text-color-7">
        <template slot="label">
          <div
            class="is-6 has-text-weight-semibold is-flex is-align-items-center"
          >
            {{ General.SITE }}
            <span class="optional-label ml-5">{{ General.OPTIONAL }}</span>
          </div>
        </template>
        <b-input
          v-model="partAddressData.site"
          maxlength="100"
          :hasCounter="false"
          :placeholder="App.PartAddressScreen.PLACEHOLDER.SITE"
        />
      </b-field>

      <div class="column is-6 mb-0 py-5">
        <b-field customClass="has-text-color-7">
          <template slot="label">
            <div
              class="is-6 has-text-weight-semibold is-flex is-align-items-center"
            >
              {{ `${General.TELEPHONE}(s)` }}
              <span class="optional-label ml-5">{{ General.OPTIONAL }}</span>
            </div>
          </template>
          <div class="is-flex is-flex-direction-column">
            <div class="custom-grid">
              <b-input
                v-model="newFone"
                v-mask="['(##) #########']"
                class="is-flex-grow-1"
                type="tel"
                :placeholder="General.PLACEHOLDER.INSERT_PHONE"
                @keyup.native.enter="addFone"
              />
              <b-button v-if="!isMobile" class="button-add" @click="addFone"
                ><b-icon
                  :type="isContrast ? 'is-white' : 'is-primary'"
                  icon="plus-circle"
                />
              </b-button>
              <label v-if="!isMobile" class="is-flex is-align-items-center">
                {{ General.ADD_PHONE }}
              </label>
            </div>
            <div
              v-for="(fone, key) in partAddressData.fones"
              :key="key"
              class="custom-grid spacing-mt-10"
            >
              <b-input
                v-model="partAddressData.fones[key]"
                v-mask="['(##) #########']"
                class="is-flex-grow-1"
                type="tel"
                disabled
              />
              <b-button class="button-add" @click="removeFone(key)"
                ><b-icon type="is-warning" icon="minus-circle" />
              </b-button>
              <label v-if="!isMobile" class="is-flex is-align-items-center">
                {{ General.REMOVE_PHONE }}
              </label>
            </div>
            <b-button v-if="isMobile" class="mobile-add" @click="addFone">
              <div class="is-flex is-align-items-center">
                <b-icon
                  :type="isContrast ? 'is-white' : 'is-primary'"
                  icon="plus-circle"
                />
                <span>{{ General.ADD_PHONE }}</span>
              </div>
            </b-button>
          </div>
        </b-field>

        <b-field customClass="has-text-color-7">
          <template slot="label">
            <div
              class="is-6 has-text-weight-semibold is-flex is-align-items-center"
            >
              {{ General.EMAIL }}
              <span class="optional-label ml-5">{{ General.OPTIONAL }}</span>
            </div>
          </template>
          <div class="custom-grid">
            <b-input
              v-model="partAddressData.email"
              maxlength="100"
              :hasCounter="false"
              :placeholder="App.PartAddressScreen.PLACEHOLDER.EMAIL"
            />
          </div>
        </b-field>
      </div>

      <div class="column is-12 has-text-color-7">
        <b-collapse
          class="collapse-custom"
          :class="{ invalidatedField: !isContrast && invalidHLogoError.length }"
          animation="slide"
        >
          <template #trigger="props">
            <div
              class="is-flex is-align-items-center is-justify-content-space-between"
            >
              <div class="simple-row">
                <div
                  id="collapse_horizontal_image"
                  class="is-6 spacing-mr-5 has-text-weight-semibold"
                >
                  {{ App.PartAddressScreen.ATTACH_HORIZONTAL_LOGO }}
                </div>
                <b-tooltip
                  multilined
                  :type="isContrast ? 'is-white' : 'is-blue-oil'"
                  :size="isMobile ? 'is-medium' : 'is-large'"
                  :position="isMobile ? 'is-top' : 'is-right'"
                >
                  <template v-slot:content>
                    <div class="has-text-left">
                      <b>
                        {{ General.INFORMATION }}
                      </b>
                      <p>
                        {{ General.TEXTS.INFO_HORIZONTAL_LOGO }}
                      </p>
                    </div>
                  </template>
                  <div class="is-flex">
                    <b-icon
                      class="spacing-ml-5"
                      :type="isContrast ? 'is-white' : 'is-blue-oil'"
                      size="is-small"
                      icon="information"
                    />
                  </div>
                </b-tooltip>
              </div>
              <b-icon
                size="is-medium"
                :icon="props.open ? 'chevron-up' : 'chevron-down'"
              />
            </div>
          </template>
          <div>
            <ListAttachedLogos
              :isLinked="partAddressData.bound"
              :imageList="getHorizontalLogos"
            />
          </div>
        </b-collapse>
        <ErrorField
          class="mt-10 has-text-refused"
          :errors="invalidHLogoError"
          tag="div"
        />
        <b-collapse class="collapse-custom mt-20" animation="slide">
          <template #trigger="props">
            <div
              class="is-flex is-align-items-center is-justify-content-space-between"
            >
              <div class="simple-row">
                <div
                  id="collapse_vertical_image"
                  class="is-6 spacing-mr-5 has-text-weight-semibold"
                >
                  {{ App.PartAddressScreen.ATTACH_VERTICAL_LOGO }}
                </div>
                <div class="optional-label">
                  {{ General.OPTIONAL }}
                </div>
                <b-tooltip
                  multilined
                  :type="isContrast ? 'is-white' : 'is-blue-oil'"
                  :size="isMobile ? 'is-small' : 'is-large'"
                  :position="isMobile ? 'is-top' : 'is-right'"
                >
                  <template v-slot:content>
                    <div class="has-text-left">
                      <b>
                        {{ General.INFORMATION }}
                      </b>
                      <p>
                        {{ General.TEXTS.INFO_VERTICAL_LOGO }}
                      </p>
                    </div>
                  </template>
                  <div class="is-flex">
                    <b-icon
                      class="spacing-ml-5"
                      :type="isContrast ? 'is-white' : 'is-blue-oil'"
                      size="is-small"
                      icon="information"
                    />
                  </div>
                </b-tooltip>
              </div>
              <b-icon
                size="is-medium"
                :icon="props.open ? 'chevron-up' : 'chevron-down'"
              />
            </div>
          </template>
          <div>
            <ListAttachedLogos
              isVertical
              :isLinked="partAddressData.bound"
              :imageList="getVerticalLogos"
            />
          </div>
        </b-collapse>
        <p class="optional-label pt-10 has-text-color-8 has-text-weight-normal">
          {{ App.PartAddressScreen.MESSAGES.FILE_FORMAT_SIZE }}
        </p>
      </div>
      <div class="column is-12">
        <div class="is-flex" :class="{ 'is-flex-direction-column': isMobile }">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            class="has-text-weight-semibold"
            size="is-size-5"
            @click="applyPartAddress"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-orange'"
            class="is-outlined spacing-ml-20"
            :class="{ 'ml-0 mt-10': isMobile }"
            size="is-size-5"
            @click="close"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { App, General } from "@/utils/constants";
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import ListAttachedLogos from "@/components/ListAttachedLogos";
import ModalWarning from "@/views/App/ModalWarning.vue";
import { validate } from "vee-validate";

export default {
  name: "PartAddress",

  components: {
    ListAttachedLogos
  },

  props: {
    id: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      filteredParts: [],
      filterCapacityTo: "",
      partDataName: "",
      maxFileSize: 10500000,
      newFone: "",
      newEmail: "",
      partAddressData: {
        partDataName: "",
        capacityDataName: "",
        partData: {},
        capacityData: {},
        zipCode: "",
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        site: "",
        fones: [],
        email: "",
        bound: false,
        isApplicableUnity: false
      },
      invalidHLogoError: []
    };
  },

  computed: {
    ...mapGetters({
      getFilteredParts: "getFilteredParts",
      getParts: "getParts",
      getCurrentPartAddress: "getCurrentPartAddress",
      hasPermission: "hasPermission",
      getCurrentUser: "getCurrentUser",
      getCapacityByOrgan: "getCapacitiesFiltered",
      getPartAddressBySeo: "getPartAddressBySeo",
      getCapacityById: "getCapacityById",
      getHorizontalLogos: "getListHorizontalLogos",
      getVerticalLogos: "getListVerticalLogos",
      fileTypes: "getFileTypes",
      getPartsById: "getPartsById",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),

    getPartWithPermission() {
      if (this.hasPermission(userPermissions["MANAGE_ADDRESS_ADM"]))
        return this.getParts;
      if (
        this.hasPermission(userPermissions["MANAGE_ADDRESS_PART"]) ||
        this.hasPermission(userPermissions["MANAGE_ADDRESS_CAPACITY"])
      ) {
        return this.getParts.filter(
          part => part.id === this.getCurrentUser.capacity.part_id
        );
      }
      return [];
    },

    disabledPartField() {
      return !this.hasPermission(userPermissions["MANAGE_ADDRESS_ADM"]);
    },

    disabledCapacityField() {
      return (
        !this.partAddressData.partDataName ||
        !(
          this.hasPermission(userPermissions["MANAGE_ADDRESS_ADM"]) ||
          this.hasPermission(userPermissions["MANAGE_ADDRESS_PART"])
        )
      );
    },

    userCapacity() {
      return this.getCapacityById(this.getCurrentUser?.capacity.capacity_id);
    }
  },

  watch: {
    getCurrentPartAddress: {
      handler(value) {
        if (value && this.id) {
          const part = value.part_id && this.getPartsById(value.part_id);
          const capacity =
            value.capacity_id && this.getCapacityById(value.capacity_id);
          this.partAddressData = {
            ...value,
            partDataName:
              value.part_id && `${part.name} - ${part.abbreviation}`,
            capacityDataName:
              value.capacity_id &&
              `${capacity.abbreviation} - ${capacity.description}`,
            capacityData: value.capacity_id && capacity,
            partData: value.part_id && part,
            zipCode: value.zip_code,
            bound: value.bound
          };
          const { horizontal_logos, vertical_logos } = this.formatLogos(
            value.logo
          );
          this.setListHorizontalLogos(horizontal_logos);
          this.setListVerticalLogos(vertical_logos);
        }
      }
    },
    getPartAddressBySeo: {
      handler(value) {
        this.partAddressData = {
          ...this.partAddressData,
          zipCode: `${value.zip_code.substring(
            0,
            5
          )}-${value.zip_code.substring(5)}`,
          street: value.street,
          number: value.number,
          district: value.district,
          complement: value.complement,
          city: value.city,
          state: value.state
        };
      }
    },
    userCapacity: {
      handler() {
        if (!this.id) this.mountPage();
      },
      immediate: true
    }
  },

  async beforeMount() {
    this.isLoading = true;
    this.setListHorizontalLogos([]);
    this.setListVerticalLogos([]);
    await this.$store.dispatch("fileTypesRequest", { state: true });
    if (this.id) {
      await this.partAddressByIdRequest(this.id);
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      createPartAddress: "createPartAddress",
      updatePartAddress: "updatePartAddress",
      partAddressByIdRequest: "partAddressByIdRequest",
      partAddressSeoByIdRequest: "partAddressSeoByIdRequest",
      fileTypesRequest: "fileTypesRequest"
    }),

    ...mapMutations({
      setListHorizontalLogos: "setListHorizontalLogos",
      setListVerticalLogos: "setListVerticalLogos"
    }),

    getPart(text) {
      const listParts = this.getPartWithPermission;
      this.filteredParts = listParts
        .filter(
          part =>
            `${part.name} ${part.abbreviation}`
              .toLowerCase()
              .includes(text.toLowerCase()) && part.id > 0
        )
        .map(part => ({
          ...part,
          displayName: `${part.name} - ${part.abbreviation}`
        }));
    },

    async setPartData(data) {
      if (data) {
        this.isLoading = true;
        await this.partAddressSeoByIdRequest(data.id);
        this.partAddressData.partData = data;
        this.isLoading = false;
      }
    },

    async setCapacityData(data) {
      if (data) {
        this.partAddressData.capacityData = data;
        this.partAddressData.capacityDataName = data.name;
      }
    },

    setFilterCapacityTo(text) {
      this.filterCapacityTo = text;
    },

    addFone() {
      if (this.newFone.length > 14 || this.newFone.length < 13)
        this.snackToast.open({
          message: `${App.PartAddressScreen.MESSAGES.INVALID_NUMBER}.`,
          type: "is-danger",
          duration: 8000
        });
      else if (this.partAddressData.fones.length < 2) {
        this.partAddressData.fones.push(this.newFone);
        this.newFone = "";
      } else
        this.snackToast.open({
          message: `${App.PartAddressScreen.MESSAGES.PHONE_LIMIT}!`,
          type: "is-danger",
          duration: 8000
        });
    },

    foneMask(value) {
      let mask = value;
      if (mask.length > 10) {
        mask = mask.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
      } else if (mask.length > 5) {
        mask = mask.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
      } else if (mask.length > 2) {
        mask = mask.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
      } else {
        mask = mask.replace(/^(\d*)/, "($1");
      }

      return [mask];
    },

    removeFone(index) {
      this.partAddressData.fones.splice(index, 1);
    },

    validateFones(fones) {
      return !JSON.parse(fones).some(fone => fone.length < 13);
    },

    validateEmail(email) {
      const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return regex.test(email);
    },

    validateSite(site) {
      const regex = /^(https?:\/\/)?(www\.)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/gi;
      return regex.test(site);
    },

    validationsBeforeRequest(data) {
      const msg = [];

      !data.part_id &&
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_ORGAN_ENTITY);

      Boolean(data.zip_code) &&
        data.zip_code.length !== 9 &&
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_CEP);

      Boolean(data.site) &&
        !this.validateSite(data.site) &&
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_SITE);

      Boolean(data.email) &&
        !this.validateEmail(data.email) &&
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_EMAIL);

      Boolean(data.fones) &&
        !this.validateFones(data.fones) &&
        msg.push(App.PartAddressScreen.MESSAGES.INVALID_PHONE);

      !data.logo?.some(image => image.logo_type === "HORIZONTAL") &&
        msg.push(
          App.PartAddressScreen.MESSAGES.REQUIRED_LOGO.replace(
            "(LOGO_NAME)",
            App.PartAddressScreen.HORIZONTAL_LOGO
          )
        );

      !data.logo?.every(image => image.document_type?.length > 0) &&
        msg.push(App.PartAddressScreen.MESSAGES.TYPE_NECESSARY);

      if (msg.length) {
        this.snackToast.open({
          message: `${
            App.PartAddressScreen.MESSAGES.ERROR_ON_FIELDS
          }: ${msg.join(", ")}.`,
          type: "is-danger",
          duration: 8000
        });
        return false;
      } else return true;
    },

    async setInvalidHLogoError() {
      const { valid: isValid } = await validate(
        this.getHorizontalLogos,
        "required"
      );
      this.invalidHLogoError = isValid
        ? []
        : [General.MESSAGES.VALIDATE.REQUIRED];

      return isValid;
    },

    async createOrUpdatePartAddress(finalData) {
      if (this.validationsBeforeRequest(finalData)) {
        this.isLoading = true;
        const status = !this.id
          ? await this.createPartAddress(finalData)
          : await this.updatePartAddress({
              partId: this.id,
              partData: finalData
            });

        this.isLoading = false;

        if (status) {
          this.snackToast.open({
            message: this.id
              ? this.General.SUCCESS_UPDATED
              : this.General.SUCCESS_CREATED,
            type: "is-success",
            duration: 8000
          });
          this.close();
        }
      }
    },

    async applyPartAddress() {
      if (await this.setInvalidHLogoError()) {
        const logo = [];

        const imageName = name => {
          const strList = name.split("/");
          return strList.pop();
        };

        const addImage = image => {
          if (!image.isNew) image.image = null;
          image.name = imageName(image.name);
          logo.push({
            ...image,
            document_type: image.document_type?.map(type => type.id)
          });
        };

        this.getHorizontalLogos.forEach(addImage);
        this.getVerticalLogos.forEach(addImage);

        const finalData = {
          part_id: this.partAddressData.partData?.id,
          capacity_id: this.partAddressData.capacityData
            ? this.partAddressData.capacityData.id
            : null,
          zip_code: this.partAddressData.zipCode,
          street: this.partAddressData.street,
          number: this.partAddressData.number,
          district: this.partAddressData.district,
          complement: this.partAddressData.complement,
          city: this.partAddressData.city,
          state: this.partAddressData.state,
          fones:
            this.partAddressData.fones.length === 0
              ? "[]"
              : JSON.stringify(this.partAddressData.fones),
          email:
            this.partAddressData.email === ""
              ? null
              : this.partAddressData.email,
          site:
            this.partAddressData.site === "" ? null : this.partAddressData.site,
          bound: this.partAddressData.bound,
          logo
        };

        this.createOrUpdatePartAddress(finalData);
      }
    },

    checkInput() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalWarning,
        props: {
          title: this.General.WARNING,
          message: this.partAddressData.bound
            ? App.PartAddressScreen.MESSAGES.MARK
            : App.PartAddressScreen.MESSAGES.UNMARK,
          confirm: () => {
            this.setListVerticalLogos([]);
            this.setListHorizontalLogos([]);
          },
          deny: () =>
            (this.partAddressData.bound = !this.partAddressData.bound),
          buttons: [
            { label: General.YES, isConfirm: true, action: true },
            { label: General.NO, isConfirm: false, action: false }
          ],
          isMessageCentered: true,
          invertOutline: true
        },
        hasModalCard: true,
        trapFocus: true,
        onCancel: () =>
          (this.partAddressData.bound = !this.partAddressData.bound)
      });
    },

    formatLogos(logos) {
      const horizontal_logos = [],
        vertical_logos = [];
      for (const logo of logos) {
        const newLogo = {
          ...logo,
          document_type: logo.document_type.map(id =>
            this.fileTypes.find(type => type.id === id)
          )
        };
        if (logo.logo_type === this.App.PartAddressScreen.LOGO_TYPE.VERTICAL) {
          vertical_logos.push(newLogo);
        } else {
          horizontal_logos.push(newLogo);
        }
      }
      return { horizontal_logos, vertical_logos };
    },

    close() {
      this.$router.back();
    },

    async mountPage() {
      if (!this.userCapacity) return;
      this.isLoading = true;
      const partCurrentUser = {
        id: this.userCapacity.entity.id,
        name: this.userCapacity.entity.name,
        abbreviation: this.userCapacity.entity.abbreviation
      };
      this.partAddressData.partData = partCurrentUser;
      this.partAddressData.partDataName = `${partCurrentUser?.name} - ${partCurrentUser?.abbreviation}`;
      if (this.hasPermission(userPermissions["MANAGE_ADDRESS_CAPACITY"])) {
        this.partAddressData.capacityData = this.userCapacity;
        this.partAddressData.capacityDataName = `${this.userCapacity.abbreviation} - ${this.userCapacity.description}`;
      }
      await this.partAddressSeoByIdRequest(partCurrentUser.id);
      this.isLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.section {
  background-color: $color-1;
  padding: 20px 1.5rem 20px 1.5rem;
}

.optional-label {
  font-size: 12px;
  font-weight: 300;
  color: $color-13;
}

.upload-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 10px;
  border-left: 3px solid $green-dark;
  margin-bottom: 15px;

  .label {
    display: flex;
    align-items: center;
  }

  .upload-button {
    display: flex;
    align-items: center;
    background-color: $white;
    border-color: $primary;
    border: 1px solid;
    border-radius: 4px;
    color: $primary;
    cursor: pointer;
    padding: calc(0.5em - 1px) 1em calc(0.5em - 1px) 1em;

    white-space: nowrap;

    height: 2.5em;
    user-select: none;
  }
}
.logo-img {
  max-width: 150px;
}

.empty {
  @media only screen and (max-width: $tablet) {
    display: none;
  }
}

.button-add {
  width: 20px;
  margin: 0px 5px;
  cursor: pointer;
  border: none;
  background-color: transparent;

  @media screen and (max-width: 767px) {
    justify-self: center;
  }
}

.simple-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.mobile-add {
  border-width: 0;
  justify-content: flex-start;
  background-color: $color-1;
  color: $color-7;

  &:focus {
    box-shadow: none;
  }
}

.custom-grid {
  display: grid;
  grid-template-columns: 10fr 1fr 4fr;
  @media screen and (max-width: $tablet) {
    display: flex;
  }
}
</style>
